export enum InterventionDefinitionTypeEnum {
  Predefined = 1,
  Custom = 2
}

export const InterventionDefinitionTypeOptions = [
{ id: 1, label: 'Predefined' },
{ id: 2, label: 'Custom' }
];
